import script from "./AppTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTabs.vue?vue&type=script&setup=true&lang=ts"

import "./AppTabs.vue?vue&type=style&index=0&id=25726e53&lang=scss"

const __exports__ = script;

export default __exports__